<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 17.8L15.5 12.4L10 7" class="stroke-current" />
  </svg>
</template>
